/**
 * IPAPI Geolocation - Auto redirect based on visitor's country
 * Redirects visitors from France to fr-fr and Germany to de-de
 */
(function() {
  'use strict';

  // Configuration
  const STORAGE_KEY = 'ipapi_lang_redirected';
  
  // IPAPI Token - Replace with your token from https://ipapi.co/dashboard/
  // Leave empty string '' if using free tier (limited to 1000 requests/day)
  const IPAPI_TOKEN = '685a9f8e4c0916b02f1d9551a3e06c6d'; // TODO: Add your ipapi.co token here
  
  // Build API URL with token if provided
  const IPAPI_URL = IPAPI_TOKEN 
    ? `https://ipapi.co/json/?access_key=${IPAPI_TOKEN}`
    : 'https://ipapi.co/json/';
  
  // Country to locale mapping
  const COUNTRY_LOCALE_MAP = {
    'FR': 'fr-fr',
    'DE': 'de-de',
    'NL': 'nl-nl',
    'BE': 'nl-be',
    'AT': 'de-at'
  };

  /**
   * Get current locale from URL
   * Returns locale code (e.g., 'en-de', 'fr-fr') or null
   */
  function getCurrentLocale() {
    const pathSegments = window.location.pathname.split('/').filter(seg => seg.length > 0);
    if (pathSegments.length > 0) {
      const firstSegment = pathSegments[0];
      // Check if it matches locale pattern (e.g., en-de, fr-fr, de-de)
      if (firstSegment.match(/^[a-z]{2}-[a-z]{2}$/i)) {
        return firstSegment.toLowerCase();
      }
    }
    return null;
  }

  /**
   * Build redirect URL with new locale
   */
  function buildRedirectUrl(newLocale) {
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split('/').filter(seg => seg.length > 0);
    
    // Remove existing locale if present
    if (pathSegments.length > 0 && pathSegments[0].match(/^[a-z]{2}-[a-z]{2}$/i)) {
      pathSegments.shift();
    }
    
    // Build new path with locale
    const newPath = '/' + newLocale + (pathSegments.length > 0 ? '/' + pathSegments.join('/') : '');
    const newUrl = window.location.origin + newPath + window.location.search + window.location.hash;
    
    return newUrl;
  }

  /**
   * Check if redirect should be performed
   */
  function shouldRedirect() {
    // Don't redirect if already redirected in this session
    if (sessionStorage.getItem(STORAGE_KEY) === 'true') {
      return false;
    }

    // Don't redirect if user has manually selected a language (stored preference)
    if (localStorage.getItem(STORAGE_KEY) === 'manual') {
      return false;
    }

    // Get current locale
    const currentLocale = getCurrentLocale();
    
    // If already in correct locale for detected country, don't redirect
    // (This will be checked after API call)
    
    return true;
  }

  /**
   * Perform redirect to new locale
   */
  function redirectToLocale(locale) {
    const redirectUrl = buildRedirectUrl(locale);
    
    // Mark as redirected in session storage
    sessionStorage.setItem(STORAGE_KEY, 'true');
    
    // Perform redirect
    window.location.replace(redirectUrl);
  }

  /**
   * Main function to detect country and redirect
   */
  function detectAndRedirect() {
    // Check if we should attempt redirect
    if (!shouldRedirect()) {
      return;
    }

    // Get current locale
    const currentLocale = getCurrentLocale();

    // If user is already in a target locale (fr-fr or de-de), 
    // we can skip the API call as they're already localized
    const targetLocales = Object.values(COUNTRY_LOCALE_MAP);
    if (currentLocale && targetLocales.includes(currentLocale)) {
      // User is already in a localized version, no need to check
      return;
    }

    // Fetch country from ipapi
    fetch(IPAPI_URL)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        const countryCode = data.country_code;
        
        // Check if we have a mapping for this country
        if (countryCode && COUNTRY_LOCALE_MAP[countryCode]) {
          const targetLocale = COUNTRY_LOCALE_MAP[countryCode];
          
          // Only redirect if not already in the correct locale
          if (currentLocale !== targetLocale) {
            redirectToLocale(targetLocale);
          }
        }
      })
      .catch(error => {
        // Silently fail - don't interrupt user experience if API fails
        console.log('IPAPI geolocation failed:', error);
      });
  }

  // Run detection on page load
  // Use immediate execution to run as early as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', detectAndRedirect);
  } else {
    // DOM already loaded, run immediately
    detectAndRedirect();
  }

  // Also expose function to mark manual language selection
  // This can be called when user manually selects a language
  window.markManualLanguageSelection = function() {
    localStorage.setItem(STORAGE_KEY, 'manual');
  };
})();
